import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { UserComponent } from 'app/layout/common/user/user.component';
import { UserProfileModule } from 'app/modules/user-profile/user-profile.module';
import { SharedModule } from 'app/shared/shared.module';
import { SharedStoreModule } from 'app/store/shared-store/shared-store.module';

@NgModule({
  declarations: [UserComponent],
  imports: [
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    SharedModule,
    UserProfileModule,
    SharedStoreModule,
  ],
  exports: [UserComponent],
})
export class UserModule {}
